export { StoreFrontAltEdit as default } from './StoreFrontAltEdit';
